import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { FileText, Image as ImageIcon, ExternalLink, Download, AlertTriangle } from 'lucide-react';

const DocView = () => {
  const location = useLocation();
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const src = params.get('url') || '';
  const title = params.get('title') || 'Documento';

  const ext = useMemo(() => {
    try {
      const url = new URL(src, window.location.origin);
      const pathname = url.pathname.toLowerCase();
      const match = pathname.match(/\.([a-z0-9]+)$/);
      return match ? match[1] : '';
    } catch (_) {
      const match = src.toLowerCase().match(/\.([a-z0-9]+)(\?|#|$)/);
      return match ? match[1] : '';
    }
  }, [src]);

  const isImage = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp'].includes(ext);
  const isPdf = ext === 'pdf';

  const handleOpenNewTab = () => {
    if (!src) return;
    window.open(src, '_blank', 'noopener,noreferrer');
  };

  const handleDownload = () => {
    if (!src) return;
    const a = document.createElement('a');
    a.href = src;
    a.download = '';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div className="space-y-4">
      <div className="card">
        <div className="card-header">
          <div className="flex items-center gap-2">
            {isImage ? (
              <ImageIcon className="w-5 h-5 text-primary-color" />
            ) : (
              <FileText className="w-5 h-5 text-primary-color" />
            )}
            <h2 className="card-title">{title}</h2>
          </div>
          <div className="flex items-center gap-2">
            <button onClick={handleOpenNewTab} className="btn btn-outline">
              <ExternalLink className="w-4 h-4 mr-2" /> Abrir em nova aba
            </button>
            <button onClick={handleDownload} className="btn btn-primary">
              <Download className="w-4 h-4 mr-2" /> Baixar
            </button>
          </div>
        </div>
        <div className="card-body">
          {!src ? (
            <div className="flex items-center gap-2 text-warning-color">
              <AlertTriangle className="w-5 h-5" />
              <span>Nenhuma URL fornecida. Use `?url=` para visualizar um documento.</span>
            </div>
          ) : (
            <div className="rounded-lg overflow-hidden border border-gray-200 bg-white" style={{ height: '70vh' }}>
              {isImage ? (
                <div className="w-full h-full flex items-center justify-center bg-gray-50">
                  <img src={src} alt={title} className="max-w-full max-h-full object-contain" />
                </div>
              ) : isPdf ? (
                <iframe title={title} src={src} className="w-full h-full" />
              ) : (
                <iframe title={title} src={src} className="w-full h-full" />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DocView;